// @ts-nocheck
import { BudgetPeriodType } from "@insite/client-framework/Store/Pages/BudgetManagement/BudgetManagementReducer";
import setBudgetCalendar from "@insite/client-framework/Store/Pages/BudgetManagement/Handlers/SetBudgetCalendar";
import {
    AssignCalendar,
    chain,
} from "@insite/client-framework/Store/Pages/BudgetManagement/Handlers/SetBudgetPeriodType";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, AssignCalendar, props => {
    const budgetState = props.getState().pages.budgetManagement;
    const budgetCalendar = budgetState.budgetCalendar;
    const budgetPeriodType = budgetState.budgetPeriodType;
    const customBudgetPeriodNumber = budgetState.customBudgetPeriodNumber;
    if (!budgetCalendar || !budgetPeriodType) {
        return;
    }

    const budgetPeriods: Date[] = [];
    let periodCount = 12;
    let step = 1;
    switch (budgetPeriodType) {
        case BudgetPeriodType.Monthly:
            periodCount = 12;
            step = 1;
            break;
        case BudgetPeriodType.Quarterly:
            periodCount = 4;
            step = 3;
            break;
        case BudgetPeriodType.Yearly:
            periodCount = 1;
            step = 12;
            break;
        case BudgetPeriodType.Custom:
            periodCount = customBudgetPeriodNumber || 1;
            step = 1;
            break;
    }

    /* Store Custom Code - Start */
    if (budgetCalendar?.budgetPeriods?.length === periodCount) {
        return;
    }
    /* Store Custom Code - End */

    for (let i = 0; i < periodCount; i += 1) {
        budgetPeriods.push(new Date(budgetCalendar.fiscalYear, i * step, 1));
    }

    props.dispatch(
        setBudgetCalendar({
            value: {
                ...budgetCalendar,
                budgetPeriods,
            },
        }),
    );
});
